import { api } from '@/api';

export interface ListOrg {
  name: string;
  orgId: string;
}

export interface ListOrgsResponse {
  orgs: ListOrg[];
}

const listOrgsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getListOrgs: builder.query<ListOrgsResponse, void>({
      query: () => ({
        url: `debug/list-orgs`,
        method: 'GET',
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetListOrgsQuery } = listOrgsApi;
